/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {FcVirtualScrollerModule} from '../fc-virtual-scroller/fc-virtual-scroller.module';
import {FcAgDropDownListComponent} from './fc-ag-drop-down-list.component';

/**
 * Drop down module with Angular.
 */
@NgModule({
    declarations: [
        FcAgDropDownListComponent
    ],
    imports: [
        FormsModule,
        BrowserModule,
        FcVirtualScrollerModule
    ],
    exports: [
        FcAgDropDownListComponent
    ]
})
export class FcResponsiveAgDropDownListModule {
}